import React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import { Link, useLocation, useParams } from "react-router-dom";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

function samePageLinkNavigation(event) {
    if (
        event.defaultPrevented ||
        event.button !== 0 || // ignore everything but left-click
        event.metaKey ||
        event.ctrlKey ||
        event.altKey ||
        event.shiftKey
    ) {
        return false;
    }
    return true;
}

function LinkTab(props) {
    return (
        <Tab
            component="a"
            onClick={(event) => {
                if (samePageLinkNavigation(event)) {
                    event.preventDefault();
                }
            }}
            aria-current={props.selected && "page"}
            {...props}
        />
    );
}

LinkTab.propTypes = {
    selected: PropTypes.bool,
};

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return { id: `simple-tab-${index}`, "aria-controls": `simple-tabpanel-${index}` };
}

const TAB_INDEXES = {
    IMAGES: 2,
    AMENITY: 4,
    PRICES: 3
}

function checkPage(page) {
    switch (page.split("/")[page.split("/").length - 1]) {
        case "images":
            return TAB_INDEXES.IMAGES;
        case "amenity":
            return TAB_INDEXES.AMENITY;
        case "prices":
            return TAB_INDEXES.PRICES;

        default:
            return 1;
    }
}

export default function HotelCategoryTabs() {
    const { hotelid, categoryid } = useParams();
    const location = useLocation();
    const [value, setValue] = React.useState(checkPage(location.pathname));
    const hotelname = sessionStorage.getItem("hotelname");
    const categoryname = sessionStorage.getItem("categoryname");

    const handleChange = (event, newValue) => {
        if (event.type !== "click" || (event.type === "click" && samePageLinkNavigation(event))) {
            setValue(newValue);
        }
    };

    const [anchor, setAnchor] = React.useState(null);
    const openMenu = (event, elem) => {
        setAnchor(event.currentTarget);
    };

    const closeMenu = () => {
        setAnchor(null);
    };

    return (
        <Box sx={{ borderBottom: 1, borderColor: "divider" }} className="hotel-category-tabs">
            <Tabs value={value} onChange={handleChange} aria-label="nav tabs example" role="navigation">
                <Tab
                    component={Link}
                    label={
                        <div>
                            <ArrowBackIosNewIcon fontSize="small" />
                            Back
                        </div>
                    }
                    to={`/hotel/${hotelid}/category`}
                    {...a11yProps(0)}
                />
                <Tab
                    label={
                        <div>
                            <div className="hotel-category-name-on-tab">
                                <HomeWorkIcon fontSize="small" /> {hotelname}
                            </div>{" "}
                            <div className="hotel-category-name-on-tab">
                                <ArrowForwardIosIcon fontSize="small" /> {categoryname}
                            </div>
                        </div>
                    }
                    disabled
                    {...a11yProps(1)}
                />
                <React.Fragment>
                    <Tab
                        component={Link}
                        className="hotel-category-tab-menu-pc-item"
                        label="Images"
                        to={`/hotel/${hotelid}/category/${categoryid}/images`}
                        {...a11yProps(2)}
                    />
                    <Tab
                        component={Link}
                        className="hotel-category-tab-menu-pc-item"
                        label="Prices"
                        to={`/hotel/${hotelid}/category/${categoryid}/prices`}
                        {...a11yProps(4)}
                    />
                    <Tab
                        component={Link}
                        className="hotel-category-tab-menu-pc-item"
                        label="Amenities"
                        to={`/hotel/${hotelid}/category/${categoryid}/amenity`}
                        {...a11yProps(3)}
                    />
                </React.Fragment>
                <div className="hotel-category-tab-menu-mb" {...a11yProps(40)}>
                    <IconButton style={{ borderRadius: "50%", width: "48px", height: "48px" }} onClick={openMenu}>
                        <MenuIcon />
                    </IconButton>
                    <Menu
                        sx={{ mt: "23px" }}
                        id="menu-appbar"
                        anchorOrigin={{ vertical: "top", horizontal: "right" }}
                        transformOrigin={{ vertical: "top", horizontal: "right" }}
                        anchorEl={anchor}
                        open={Boolean(anchor)}
                        onClose={closeMenu}
                    >
                        <MenuItem>
                            <Tab component={Link} label="Images" to={`/hotel/${hotelid}/category/${categoryid}/images`} {...a11yProps(TAB_INDEXES.IMAGES)} />
                        </MenuItem>
                        <MenuItem>
                            <Tab component={Link} label="Prices" to={`/hotel/${hotelid}/category/${categoryid}/prices`} {...a11yProps(TAB_INDEXES.PRICES)} />
                        </MenuItem>
                        <MenuItem>
                            <Tab component={Link} label="Amenities" to={`/hotel/${hotelid}/category/${categoryid}/amenity`} {...a11yProps(TAB_INDEXES.AMENITY)} />
                        </MenuItem>
                    </Menu>
                </div>
                <div></div>
            </Tabs>
        </Box>
    );
}
